import { attr } from 'spraypaint';
import ApplicationRecord from './ApplicationRecord';

const CardAuthorisation = ApplicationRecord.extend({
  attrs: {
    card_token: attr({ type: String }),
    customer_id: attr({ type: String }),
    threeds_redirect_url: attr({ type: String, persist: false }),
    authorised: attr({ type: Boolean, persist: false }),
    checkout_response_code: attr({ type: String, persist: false }),
    checkout_response_summary: attr({ type: String, persist: false }),
    error_message: attr({ type: String, persist: false }),
  },
  static: {
    endpoint: '/card_authorisations',
    jsonapiType: 'external_payments-card_authorisations',
  },
});

export default CardAuthorisation;
